const PLACEHOLDER_PNG_SRC =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAyCAYAAAAUYybjAAAAYElEQVR42u3QQREAAAQAMOI6f1/VVRBgi7Ccrg1eUpYsWbJkyZIlS5YsWbJkyZIlS5YsWbJkyZIlS5YsWbJkyZIlS5YsWbJkyZIlS5YsWbJkyZIlS5YsWbJkyZIlS9bfAfvBWXWGB00fAAAAAElFTkSuQmCC';

export {PLACEHOLDER_PNG_SRC};
export default PLACEHOLDER_PNG_SRC;
